import Vue from 'vue';
import Router from 'vue-router';
import Login from '../view/Login';
import notfound from '../view/notfound';
Vue.use(Router)
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  //base:'/gushan/',
  mode:'history',//history将处理路劲中携带的#,另一种模式为哈希模式
  routes: [
    {
      //登录页
      path: '/login',
      //路由名称=Login组件名称
      name: 'Login',
      //路由跳转的组件
      component: Login,
      meta:{
        title: '古杉数据-官网',
        keepAlive: false,
        content: {
          keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
          description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
        }
      }
    },
    {
      //首页跳转路劲
      path: '/',
      name: 'Main',
      component: () => import('../view/Main.vue'),
      //重定向默认显示第一个children路由
      redirect:"/index",
      meta:{
        title: '官网',
        keepAlive: false,
        content: {
          keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
          description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
        }
      },
      children:[
        {
          //首页路劲
          path:'/index',
          name:'i·ndex',
          component:()=>import('../view/home'),
          meta:{
            title: '官网',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //内容路劲
          path:'/content',
          name:'Content',
          component:()=>import('../view/content'),
          meta:{
            title: '行业案例',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          },
          children:[
            {
              //能源电力
              path:'/content/energypower',
              name:'Energypower',
              component:()=>import('../view/energypower'),
              meta:{
                title: '能源电力',
                keepAlive: false,
                content: {
                  keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
                  description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
                }
              }
            },
            {
              //汽车行业
              path:'/content/cartrade',
              name:'Cartrade',
              component:()=>import('../view/cartrade'),
              meta:{
                title: '汽车行业',
                keepAlive: false,
                content: {
                  keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
                  description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
                }
              }
            },
            {
              //水利水电
              path:'/content/waterpower',
              name:'Waterpower',
              component:()=>import('../view/waterpower'),
              meta:{
                title: '水利水电',
                keepAlive: false,
                content: {
                  keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
                  description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
                }
              }
            },
          ]
        },
        {
          //产品系列
          path:'/product',
          name:'Product',
          component:()=>import('../view/product/index.vue'),
          meta:{
            title: '产品介绍',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          },
          children:[
          //  {
          //    path:'/product/description/:navkey',
          //    name:'productContent',
          //    component:()=>import('../view/product/productcontent'),
          //   meta:{
          //      title: '产品描述',
          //     keepAlive: false
          //  }
          // }
          ]
        },
        {
          path:'/product/auditplatform',
          name:'AuditPlatform',
          component:()=>import('../view/product/productType/index1.vue'),
          meta:{
            title: '审计平台类',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          path:'/product/auditresults',
          name:'AuditResults',
          component:()=>import('../view/product/productType/index2.vue'),
          meta:{
            title: '审计成果类工具',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          path:'/product/newtech',
          name:'NewTechCombin',
          component:()=>import('../view/product/productType/index3.vue'),
          meta:{
            title: '新技术结合',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          path:'/product/bigdata',
          name:'BigData',
          component:()=>import('../view/product/productType/index4.vue'),
          meta:{
            title: '大数据类',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //企业介绍
          path:'/companyInfor',
          name:'CompanyInfor',
          component:()=>import('../view/companyInfor'),
          meta:{
            title: '企业介绍',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        }, {
          //数字化转型咨询
          path:'/transform',
          name:'Transform',
          component:()=>import('../view/service/szhzx.vue'),
          meta:{
            title: '数字化转型咨询',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //数据治理咨询
          path:'/datagovern',
          name:'DataGovern',
          component:()=>import('../view/service/sjzl.vue'),
          meta:{
            title: '数据治理咨询',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //审计风控合规
          path:'/auditrisk',
          name:'AuditRisk',
          component:()=>import('../view/service/sjfkhg.vue'),
          meta:{
            title: '审计风控合规',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //数字孪生
          path:'/digitaltwins',
          name:'DigitalTwins',
          component:()=>import('../view/service/szls.vue'),
          meta:{
            title: '数字孪生',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //团队日常
          path:'/daytoday',
          name:'DayToDay',
          component:()=>import('../view/companyInfor/daytoday.vue'),
          meta:{
            title: '团队日常',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
        {
          //联系我们
          path:'/contact',
          name:'Contact',
          component:()=>import('../view/contact'),
          meta:{
            title: '联系我们',
            keepAlive: false,
            content: {
              keywords: '北京古杉，古杉数据，数字化转型，数据治理咨询，自助分析建模，数字孪生，干部画像，企业经营画像，风险矩阵，风控合规，法务管控，大数据及AI咨询规划，数据平台搭建建设，数据分析模型应用，可视化分析，Beijing',
              description: '北京古杉(官网);Beijing Gushan;北京古杉数据科技有限公司成立于2017年，现有注册资金300万，是国内领先的数字化技术产品解决方案、产品和服务提供商。公司核心团队来自于IBM、Mars、微软等头部外资企业。国内比较早聚焦专注于帮助传统企业如何更好用好数据！国内较早专注于帮助企业更好应用好数据的企业，提供核心能力包括：大数据及AI咨询规划、数据平台搭建建设、数据分析模型应用、可视化分析等！'
            }
          }
        },
      ]
    },
    {
      path:'/logout'
    },
    {
      //404组件
      path:'*',
      component:notfound
    }
   
  ]
})
